<template>
  <div v-if="sealStatus.enabled && sealStatus.secureMode">
    <v-tooltip top>
      <template #activator="{on, attrs}">
        <v-btn
          id="centralkey_modal_btn"
          v-bind="attrs"
          class="pl-1 ml-4"
          :outlined="sealStatus.activated "
          :color="sealStatus.activated ? 'grey':'primary'"
          :loading="isBtnLoading"
          v-on="on"
          @click="showDialog"
        >
          <v-icon
            class="mx-1"
            :color="sealStatus.activated? 'success': 'primary'"
          >
            {{ sealStatus.activated ? "mdi-check-circle-outline" : "mdi-key-plus" }}
          </v-icon>
          <span>{{ sealStatus.activated ? $t('users.centralKey.hasActive.button'): $t('users.centralKey.noActive.button') }}</span>
        </v-btn>
      </template>
      <span>
        {{ sealStatus.activated ? $t('users.centralKey.hasActive.tooltip'): $t('users.centralKey.noActive.tooltip') }}
      </span>
    </v-tooltip>
    <v-dialog
      v-model="shouldBeVisible"
      max-width="670"
      class="rounded-xl"
      persistent
    >
      <v-card id="centralkey_modal_card" width="100%">
        <v-card-title>{{ $t('users.centralKey.modal.title') }}</v-card-title>
        <v-card-subtitle class="mt-2">{{ $t('users.centralKey.modal.subtitle') }}</v-card-subtitle>
        <v-form ref="centralKeyForm" v-model="centralKeyFormValid" @submit.prevent="activateCentralKey">
          <v-card-text class="px-6">
            <v-container fluid>
              <v-row>
                <v-text-field
                  id="centralkey_userpwd_input"
                  v-model="userPwd"
                  autofocus
                  class="mr-6"
                  :type="showUserPwd ? 'text' : 'password'"
                  :append-icon="showUserPwd ? 'mdi-eye' : 'mdi-eye-off'"
                  :label="$t('users.centralKey.modal.userPwd')"
                  :rules="[rules.min, rules.containDigit,rules.containUppercase, rules.containLowercase, rules.containSpecial, rules.containDigit]"
                  @click:append="showUserPwd = !showUserPwd"
                ></v-text-field>
                <v-text-field
                  id="centralkey_keypwd_input"
                  v-model="keyPwd"
                  :type="showKeyPwd ? 'text' : 'password'"
                  :append-icon="showKeyPwd ? 'mdi-eye' : 'mdi-eye-off'"
                  :label="$t('users.centralKey.modal.keyPwd')"
                  :rules="[rules.min, rules.containDigit,rules.containUppercase, rules.containLowercase, rules.containSpecial, rules.containDigit]"
                  @click:append="showKeyPwd = !showKeyPwd"
                ></v-text-field>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-btn class="mr-2" @click="closeDialog()">
              <v-icon>
                mdi-close-circle-outline
              </v-icon>
              {{ $t('main.cancel') }}
            </v-btn>
            <v-btn
              id="centralkey_activate_btn"
              color="primary"
              type="submit"
              :loading="isBtnLoading"
              :disabled="!centralKeyFormValid"
              @click.prevent="activateCentralKey()"
            >
              <v-icon>
                mdi-plus-circle-outline
              </v-icon>
              {{ $t("users.centralKey.modal.activateBtn") }}
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import seal from '../services/api/seal'
import { showToastError, showToastSuccess } from '@/event-bus.js'

export default {
  name: 'CentralKeyActivationModal',

  data() {
    return {
      userPwd: '',
      keyPwd: '',
      dialogVisible: false,
      showUserPwd: false,
      showKeyPwd: false,
      sealStatus: {
        enabled: false,
        secureMode: false,
        activated: false
      },
      centralKeyFormValid: false,
      rules: {
        min: (v) => (v && v.length > 5) || this.$t('validation.form.passwordMustBeLongerThan', { min: 5 }),
        containDigit: (v) => (v && /\d/.test(v)) || this.$t('validation.form.shouldContainDigit'),
        containUppercase: (v) => (v && /[A-Z]/.test(v)) || this.$t('validation.form.shouldContainUppercase'),
        containLowercase: (v) => (v && /[a-z]/.test(v)) || this.$t('validation.form.shouldContainLowercase'),
        containSpecial: (v) => (v && /[^A-Za-z0-9]/.test(v)) || this.$t('validation.form.shouldContainSpecial')
      },
      isBtnLoading: false
    }
  },

  computed: {
    shouldBeVisible() {
      return this.dialogVisible
    }
  },

  async mounted() {
    this.sealStatus = await seal.getSealStatus()
  },

  methods: {
    async activateCentralKey() {
      if (!this.$refs.centralKeyForm.validate()) {
        return
      }

      const req = {
        userPwd: this.userPwd,
        keyPwd: this.keyPwd
      }
      try {
        this.isBtnLoading = true
        await seal.activate(req)
        showToastSuccess(this.$t('users.centralKey.successfullActivation'))
      } catch (error) {
        showToastError(this.$t('toastMessage.sealBadPwd'))
      } finally {
        this.isBtnLoading = false
      }

      this.closeDialog()
      this.sealStatus = await seal.getSealStatus()
    },

    showDialog() {
      if (!this.sealStatus.activated) {
        this.dialogVisible = true
      }
    },

    closeDialog() {
      this.dialogVisible = false
      this.userPwd = ''
      this.keyPwd = ''
    }
  }
}
</script>

<style scoped>
</style>
